import { render } from "./PartnerMenu.vue?vue&type=template&id=5e81536a&scoped=true"
import script from "./PartnerMenu.vue?vue&type=script&lang=js"
export * from "./PartnerMenu.vue?vue&type=script&lang=js"

import "./PartnerMenu.vue?vue&type=style&index=0&id=5e81536a&scoped=true&lang=css"

import exportComponent from "E:\\Data\\Repos\\Propnroll\\Propnroll\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e81536a"]])

export default __exports__